import { Text, View } from "@lightningtv/solid";
import PinKeyboard from "../../../components/PinKeyboard";
import { createSignal } from "solid-js";
import { fontFamily, isRTL, t } from "../../../translations/configuration";

export function ChangePin(props: { onPinSet: () => void; keyboardRef?: any, changePINRef?: any }) {
    const [step, setStep] = createSignal<"verifyOld" | "enterNew" | "confirmNew" | "success">("verifyOld");
    const [tempNewPin, setTempNewPin] = createSignal("");

    // Use the passed keyboardRef directly, don't create a fallback
    const keyboardRef = props.keyboardRef;
    const changePINRef = props.changePINRef;

    const handlePinSubmit = (pin: string) => {
        const savedPin = localStorage.getItem("userPin");

        if (step() === "verifyOld") {
            if (pin === savedPin) {
                setStep("enterNew");
            } else {
                console.log("Incorrect old PIN");
            }
        } else if (step() === "enterNew") {
            setTempNewPin(pin);
            setStep("confirmNew");
        } else if (step() === "confirmNew") {
            if (pin === tempNewPin()) {
                localStorage.setItem("userPin", pin);
                setStep("success");

                // Show success message for 2 seconds, then call onPinSet
                setTimeout(() => {
                    props.onPinSet(); // Done
                    // Reset to first step for potential future use
                    setStep("verifyOld");
                    setTempNewPin("");
                }, 2000);
            } else {
                console.log("PINs did not match");
                setStep("enterNew");
                setTempNewPin("");
            }
        }

        keyboardRef?.resetInput?.();
    };

    return (
        <View x={900}>
            <Text x={isRTL() ? 50 : 70} y={100} fontSize={36} style={{ fontFamily: fontFamily() }}>
                {step() === "verifyOld"
                    ? t("enterCurrentPin")
                    : step() === "enterNew"
                        ? t("enterNewPin")
                        : step() === "confirmNew"
                            ? t("confirmNewPin")
                            : t("pinChanged")}
            </Text>
            <View x={0} y={200}>
                {step() === "success" ? (
                    <View y={150}>
                        <Text x={120} y={50} fontSize={28} color={"#00ff00"} style={{ fontFamily: fontFamily() }}>
                            {t("pinHasChanged")}
                        </Text>
                    </View>
                ) : (
                    <PinKeyboard
                        onSubmit={handlePinSubmit}
                        keyboardRef={keyboardRef}
                        autoFocus={false}
                        onBackLeft={() => changePINRef.setFocus?.()}
                    />
                )}
            </View>
        </View>
    );
}